import { render, staticRenderFns } from "./TypeInput.vue?vue&type=template&id=9a5216aa&"
import script from "./TypeInput.vue?vue&type=script&lang=ts&"
export * from "./TypeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports